import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { default as React } from "react"

export function UpdateInsuranceInfoDialog({
  open,
  onClose,
  onUpdateInsurance
}: {
  open: boolean
  onClose: () => void
  onUpdateInsurance: () => void
}): JSX.Element {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <FormattedMessage defaultMessage="Partner removed" />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage defaultMessage="If you've had a qualifying life event, such as a change in marital status or insurance coverage, be sure to update your insurance information as well." />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose()
            onUpdateInsurance()
          }}
          variant="outlined"
          color="secondary"
        >
          <FormattedMessage defaultMessage="Update insurance info" />
        </Button>
        <Button onClick={onClose} variant="contained" color="primary">
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}
